export default {
    setRoom(state, room) {
        state.instance = room;
    },
    setMessages(state, messages) {
        state.messages = messages;
    },
    addTimer(state, {roomId, timerId}) {
        state.timers[roomId] = timerId;
    },
    removeTimer(state, roomId) {
        delete state.timers[roomId];
    }
}